import * as React from 'react';
import PropTypes from 'prop-types';
import Error from './error';

export default class Errorboundary extends React.Component {
  state = {
    hasError: false
  };

  componentDidCatch(error, info) {
    this.setState({
      hasError: true
    });
  }

  render() {
    const {hasError} = this.state;
    const {children} = this.props;
    if (hasError) {
      return <Error/>;
    }
    return children;
  }
}

Errorboundary.propTypes = {
  children: PropTypes.object
};
